import { combineReducers } from "redux";
import authReducer from "../../../features/auth/redux/slice";
import notifications from "./notifications";
import entities from "./entities";
import modal from "./modal";
import {
    sessionReducer as dataEntering,
    activityReducer as activity,
} from "../../../features/dataEntering/redux";
import * as purchaseInvoiceFormSlice from "../../../features/dataEntering/routes/dataEntering/components/Forms/Invoice/PurchaseInvoice/slice";
import * as salesInvoiceFormSlice from "../../../features/dataEntering/routes/dataEntering/components/Forms/Invoice/SalesInvoice/slice";
import * as pettyCashDisburstmentFormSlice from "../../../features/dataEntering/routes/dataEntering//components/Forms/PettyCash/PettyCashDisburstment/slice";
import * as pettyCashIncomeFormSlice from "../../../features/dataEntering/routes/dataEntering/components/Forms/PettyCash/PettyCashIncome/slice";
import { api as accountingApi } from "../../../services/accounting/api";
import { api as dataEnteringApi } from "../../../services/dataEntering/api";
import { api as managementApi } from "../../../services/management/api";
import { api as supervisingApi } from "../../../services/supervising/api";
import { api as authApi } from "../../../services/auth/api";
import { api as knowledgeApi } from "../../../services/knowledge/api";

const appReducer = combineReducers({
    auth: authReducer,
    entities,
    dataEntering,
    modal,
    notifications,
    activity,
    [purchaseInvoiceFormSlice.name]: purchaseInvoiceFormSlice.reducer,
    [salesInvoiceFormSlice.name]: salesInvoiceFormSlice.reducer,
    [pettyCashDisburstmentFormSlice.name]: pettyCashDisburstmentFormSlice.reducer,
    [pettyCashIncomeFormSlice.name]: pettyCashIncomeFormSlice.reducer,
    [accountingApi.reducerPath]: accountingApi.reducer,
    [dataEnteringApi.reducerPath]: dataEnteringApi.reducer,
    [managementApi.reducerPath]: managementApi.reducer,
    [supervisingApi.reducerPath]: supervisingApi.reducer,
    [authApi.reducerPath]: authApi.reducer,
    [knowledgeApi.reducerPath]: knowledgeApi.reducer,
});

export default appReducer;
